import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Lock, Eye, EyeOff, Phone } from 'lucide-react';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Signup = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        devLog('Signup form submitted:', formData);
    };

    const inputClass = "w-full pl-10 pr-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A]";

    return (
        <div className="w-full min-h-screen bg-[#F0F7FA] flex items-center justify-center px-4 py-12" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="w-full max-w-md">
                {/* Brand */}
                <div className="text-center mb-8">
                    <h1
                        className="text-2xl font-bold tracking-wider text-[#1B4965] cursor-pointer mb-2"
                        onClick={() => navigate('/template4')}
                    >
                        NEELA
                    </h1>
                    <p className="text-sm text-[#6B7280]">Create your account to get started</p>
                </div>

                {/* Form Card */}
                <div className="bg-white p-6 sm:p-8 rounded-sm border border-[#E5E7EB] shadow-sm">
                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* Full Name */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Full Name</label>
                            <div className="relative">
                                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Your full name" className={inputClass} required />
                            </div>
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Email Address</label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="you@email.com" className={inputClass} required />
                            </div>
                        </div>

                        {/* Phone */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Phone Number</label>
                            <div className="relative">
                                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+91 98765 43210" className={inputClass} required />
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Password</label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    placeholder="Create a password"
                                    className="w-full pl-10 pr-10 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A]"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#1B4965]"
                                >
                                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                                </button>
                            </div>
                        </div>

                        {/* Confirm Password */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Confirm Password</label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} placeholder="Confirm your password" className={inputClass} required />
                            </div>
                        </div>

                        <Button type="submit" variant="primary" size="lg" fullWidth>
                            Create Account
                        </Button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-[#6B7280]">
                            Already have an account?{' '}
                            <button
                                onClick={() => navigate('/template4/login')}
                                className="text-[#1B4965] hover:text-[#133B53] font-semibold bg-transparent border-none cursor-pointer"
                            >
                                Sign In
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;
